;(function (global, factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        factory(module, global);
    } else {
        factory({}, global);
    }
})(window || this, function (module, window) {
    var url = function(){

        var master = {
            'xch5.chelun.com': '//xch5.chelun.com/2016/',
            'picture.eclicks.cn': '//picture.eclicks.cn/kaojiazhao/frontend/2016/'
        };
        var hostname = location.hostname,
            isTest = master[hostname] === undefined;

        // 捕捉系统错误
        if( isTest ){
            window.onerror = function(msg, url, line){
                //alert(msg + '\n(' + url + ':' + line + ')');
            };
        }

        // 静态路径
        var staticDomain = isTest ? '//h5kjz.chelun.com/2016/' : master[hostname];
        if( hostname == 'me.chelun.com' ){// 本地
            staticDomain = '//me.chelun.com/';
        }

        // 获取url参数
        function getQueryString( name ) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = decodeURIComponent(location.search).substr(1).match(reg);
            if (r != null)
                return unescape(r[2]);
            return null;
        }

        // url参数集
        var query = function(){
            var result = {};
            var searchStr = decodeURIComponent(location.search);

            if( searchStr ){
                var keyVal,queryArr = searchStr.substr(1).split('&');
                for(var i=0,len=queryArr.length; i<len; i++){
                    keyVal = queryArr[i].split('=');
                    result[keyVal[0]] = unescape(keyVal[1] || '');
                }
            }

            return result;
        }();

        // scheme
        function scheme(url){
            var ifr = document.createElement('iframe');
            ifr.src = url;
            ifr.style.display = 'none';
            document.body.appendChild(ifr);
        }

        // forbid
        function forbidden(tips){
            tips = tips || '请在车轮驾考通APP打开链接';

            document.title = '抱歉,出错了';
            document.body.innerHTML = '<div class="ui-no-data">' + tips + '</div>';
        }

        // 完整路径
        function absolutePath(url) {
            var aE = document.createElement('a');
            aE.href = url;
            return aE.href;
        }

        return {
            isTest:         isTest,
            protocol:       location.protocol,
            query:          query,
            getQueryString: getQueryString,
            scheme:         scheme,
            forbidden:      forbidden,
            absolutePath:   absolutePath,

            xcDomain:       isTest ? '//kjzdev.eclicks.cn/kaojiazhao2/' : '//xueche.chelun.com/',
            wxDomain:       isTest ? '//kjzwxdev.eclicks.cn/' : '//kjzwx.eclicks.cn/',

            staticDomain:   staticDomain,
            download:       '//chelun.com/url/pdU2gB'
        };
    }();

    window._url = module.exports = url;
});





//////////////////
// WEBPACK FOOTER
// ./static/js/url.js
// module id = DHcU
// module chunks = 1